import { TFunction } from 'i18next';

export const CV_LENGTH_VALIDATION_ERROR =
  'Min value cannot be greater than max value';

export const ALLOWED_DISPLAY_NAME_CHARACTER_REGEX = /[^\d a-z_]/i;
export const ALLOWED_DISPLAY_NAME_LENGTH = 50;

export const getCheckboxTypeValueOptions = (t: TFunction<'action-builder'>) => [
  { label: t('checkboxTypeValueOptions.true'), value: 'true' },
  { label: t('checkboxTypeValueOptions.false'), value: 'false' },
];
